import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Text, Anchor } from '../element';
import Strings from '../../locales/Strings';
import SideBarItem from './SideBarItem';
import StepSideBarItem from './StepSideBarItem';
import { historyPush, getQueryString, getQueryStringValues } from '../../utils/withPath';
import {
  PRODUCT_NAMES,
  HPE_ALLETRA_DHCI_STORAGE,
  INSTALLATION_TYPE,
  MODEL_ALLETRAMP,
  HPE_SIMPLIVITY,
  MODEL_LIST_PCBE,
  PRODUCT_ID_ALLETRAB10K,
  MODEL_LIST_SWITCHED_B10K,
  PRIMERA_OPT_FIELD,
  PRODUCT_ID_OAAS,
} from '../../constants';
import { TYPE_INSTALLATION } from '../../constants';
import { getModelLabel } from '../../config/productsConfig';
import { getOptInfo } from '../../config/productsConfig';
import { capitalizeFirstLetter } from '../../utils/withPath';

function getPathRoot(path) {
  if (path.length === 0) {
    return path;
  }
  const pathString = path.startsWith('/') ? path.substring(1) : path;
  return pathString.split('/')[0];
}
///////////////////
///////////////////
// SideMenu //
///////////////////

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItems: this.props.pagesConfig,
      show: false,
    };
  }

  onListen = location => {
    const locationRoot = getPathRoot(location.pathname);
    let item = this.state.menuItems.find(menuObj => {
      if (menuObj.submenuItems && getPathRoot(menuObj.path) === locationRoot) {
        return menuObj;
      }
      return null;
    });
    if (!item) {
      return;
    }

    if (location.pathname.startsWith(item.path)) {
      let submenuItems = [...item.submenuItems];

      let index = submenuItems.findIndex(subItem => location.pathname.startsWith(subItem.path));

      index = index === -1 ? 0 : index;

      if (index > -1) {
        submenuItems[index].status = 'active';

        for (let i = 0; i < index; i++) {
          submenuItems[i].status = 'completed';
        }

        for (let i = index + 1; i < submenuItems.length; i++) {
          submenuItems[i].status = '';
        }

        item.submenuItems = submenuItems;
      }
    } else {
      let submenuItems = [...item.submenuItems];
      for (let i = 0; i < submenuItems.length; i++) {
        submenuItems[i].status = '';
      }
    }
  };

  componentWillMount() {
    this.listen = this.props.history.listen(location => this.onListen(location, 1));
  }

  componentWillUnmount() {
    this.listen();
  }

  componentDidMount() {
    this.onListen(this.props.location, 1);
  }

  render() {
    const locationRootPath = getPathRoot(this.props.location.pathname);
    const menuItems = this.state.menuItems
      .filter(item => item.menuText)
      .map((item, index) => {
        const queryString = getQueryString(this.props.location);
        let active = locationRootPath === getPathRoot(item.path) ? true : false;

        return item.submenuItems ? (
          <StepSideBarItem
            key={index}
            index={index}
            item={item}
            queryString={queryString}
            show={active}
            steps={item.submenuItems}
            border={{ color: '#eee', side: 'bottom', size: 'xsmall' }}
          />
        ) : (
          <SideBarItem
            key={index}
            index={index}
            item={item}
            active={active}
            queryString={queryString}
            border={{ color: '#eee', side: 'bottom', size: 'xsmall' }}
          />
        );
      });

    const { product, model, opt, cabletray } = getQueryStringValues(this.props.location);
    const productName = PRODUCT_NAMES.get(product);
    const queryStringValues = getQueryStringValues(this.props.location);
    const connectOpt = queryStringValues['connectopt'];
    const configureOpt = queryStringValues['configureopt'];
    const storagePurchaseOpt = queryStringValues['storagepurchaseopt'];
    const simplivitymodel = queryStringValues['simplivitymodel'];
    const hpeAlletraDHCImodel = queryStringValues['hpeAlletraDHCImodel'];
    const productId = this.props.productId;
    const {
      selectBoxLabel,
      selectedOptLabel,
      simplivitySelectBoxLabel,
      selectBoxLabelForHPEAlletraDHCI,
      selectBoxLabelforCableTray,
    } = getOptInfo({
      productId: productId,
      model,
      opt,
      connectOpt,
      configureOpt,
      cabletray,
    });
    const connectMethodLabelStyle = {
      height: product === PRODUCT_ID_OAAS || product === PRODUCT_ID_ALLETRAB10K ? '30px' : '',
    };
    return (
      <Box pad={{ horizontal: 'medium' }} jusify="start">
        <Box align="center" className="paddingTop5">
          <Anchor
            onClick={() => historyPush('/', this.props.location, this.props.history)}
            label={<Text className="fontSize36 lineHeightCompact light">{Strings.welcomeCenter}</Text>}
            data-test-id={'welcome-center-link'}
          />
          <Text data-test-id={'selected-product'}>{productName}</Text>
          {storagePurchaseOpt && (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{Strings.selectStoragePurchase}: </span>
                <span data-test-id="selected-purchase-option">{capitalizeFirstLetter(storagePurchaseOpt)}</span>
              </Text>
            </>
          )}
          {model && (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{getModelLabel(product)}: </span>
                <span data-test-id="selected-model">{model}</span>
              </Text>
            </>
          )}
          {((model === MODEL_ALLETRAMP || productId === PRODUCT_ID_ALLETRAB10K) &&
            selectedOptLabel &&
            selectBoxLabel === INSTALLATION_TYPE) ||
          (selectedOptLabel && selectBoxLabel === TYPE_INSTALLATION) ? (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{Strings.selectArrayModelDescInstallationType}: </span>
                <span data-test-id="selected-model">{selectedOptLabel}</span>
              </Text>
            </>
          ) : null}
          {MODEL_LIST_SWITCHED_B10K.includes(model) && opt === PRIMERA_OPT_FIELD ? (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{selectBoxLabelforCableTray}: </span>
                <span data-test-id="selected-model">{cabletray}</span>
              </Text>
            </>
          ) : null}
          {model && productName === HPE_ALLETRA_DHCI_STORAGE ? (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{Strings.configVCenter}: </span>
                <span data-test-id="selected-type">{selectedOptLabel}</span>
              </Text>
            </>
          ) : null}
          {MODEL_LIST_PCBE.includes(model) && (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{selectBoxLabelForHPEAlletraDHCI}: </span>
                <span data-test-id="selected-type">{hpeAlletraDHCImodel}</span>
              </Text>
            </>
          )}
          {model === HPE_SIMPLIVITY && (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{simplivitySelectBoxLabel}: </span>
                <span data-test-id="selected-type">{simplivitymodel}</span>
              </Text>
            </>
          )}
          {connectOpt && (
            <>
              <Text className="fontSize14" style={connectMethodLabelStyle}>
                <span>{Strings.selectConnect}: </span>
                <span data-test-id="selected-connect-option">{connectOpt}</span>
              </Text>
            </>
          )}
          {configureOpt && (
            <>
              <Text className="fontSize14" style={{ height: '15px' }}>
                <span>{Strings.selectConfiguration}: </span>
                <span data-test-id="selected-connect-option">{configureOpt}</span>
              </Text>
            </>
          )}
        </Box>
        {/* <Box
          data-test-id={`${productName}-page`}
          style={{ alignItems: 'left', backgroundColor: '#F4F6F9' }}
          pad={{ left: 'small' }}
          justify="center">
          <Text className="fontSize14">{productName}</Text>
        </Box> */}
        <Box pad={{ left: 'small' }} align="center">
          {menuItems}
        </Box>
      </Box>
    );
  }
}

export default withRouter(SideMenu);
